import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';
import type { FamilyInviteLink } from 'reactApp/modules/family/family.types';

export class GetFamilyInviteLinkAPICall extends APICallV4<FamilyInviteLink> {
    _method = 'family/link';
    _type: Method = 'get';
    _retriesCount = 0;
}
